import React from 'react'

export function NotStartedMedallion(props: any) {
  const { height, width } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_ii_1167_55283)">
        <path
          d="M11.8996 1.31826C13.1133 0.0539496 15.1367 0.0539498 16.3504 1.31826V1.31826C17.1053 2.10476 18.2201 2.4341 19.2812 2.18364V2.18364C20.9783 1.78304 22.6749 2.89734 23.016 4.60736V4.60736C23.2298 5.67919 23.9926 6.57603 25.0212 6.94557V6.94557C26.6682 7.53729 27.4968 9.3901 26.8658 11.0224V11.0224C26.4705 12.0449 26.6339 13.2146 27.2999 14.0853V14.0853C28.3675 15.481 28.0848 17.488 26.6672 18.5263V18.5263C25.7839 19.1732 25.3035 20.2507 25.3974 21.3414V21.3414C25.547 23.08 24.2333 24.6288 22.4911 24.7276V24.7276C21.4016 24.7894 20.4206 25.4288 19.9165 26.3966V26.3966C19.1096 27.9455 17.1685 28.5285 15.6524 27.6614V27.6614C14.7061 27.1201 13.5439 27.1201 12.5976 27.6614V27.6614C11.0815 28.5285 9.14042 27.9455 8.33351 26.3966V26.3966C7.82935 25.4288 6.84842 24.7894 5.75894 24.7276V24.7276C4.0167 24.6288 2.70301 23.08 2.85265 21.3414V21.3414C2.94653 20.2507 2.46609 19.1732 1.58284 18.5263V18.5263C0.165174 17.488 -0.117525 15.481 0.950096 14.0853V14.0853C1.6161 13.2146 1.77947 12.0449 1.38421 11.0224V11.0224C0.753191 9.3901 1.58181 7.53729 3.22881 6.94557V6.94557C4.25739 6.57603 5.02022 5.67919 5.23402 4.60736V4.60736C5.57514 2.89734 7.27173 1.78304 8.96881 2.18364V2.18364C10.0299 2.4341 11.1447 2.10476 11.8996 1.31826V1.31826Z"
          fill="#D9DBDD"
        />
      </g>
      <rect
        width="5.66421"
        height="1.94487"
        rx="0.972434"
        transform="matrix(0.699674 0.714462 -0.699674 0.714462 9.66379 13.1766)"
        fill="#ECEDEE"
      />
      <rect
        width="10.7977"
        height="1.94487"
        rx="0.972434"
        transform="matrix(-0.699674 0.714463 -0.699674 -0.714463 19.9543 10.939)"
        fill="#ECEDEE"
      />
      <defs>
        <filter
          id="filter0_ii_1167_55283"
          x="-2.69696"
          y="-1.62997"
          width="32.6439"
          height="31.6942"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="2.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.887695 0 0 0 0 0.887695 0 0 0 0 0.887695 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1167_55283" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-3" dy="-2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.829362 0 0 0 0 0.829362 0 0 0 0 0.829362 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_1167_55283"
            result="effect2_innerShadow_1167_55283"
          />
        </filter>
      </defs>
    </svg>
  )
}
